import React, { Dispatch, SetStateAction } from 'react';

import { Icon, IconButton, Switch } from '@atom/mui';
import { AssetRequestCreateInput } from '@atom/types/assetRequest';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { View } from '../CreateRequestModal';

import './ardotCreate.css';

const styles = {
  switch: {
    margin: '0',
  },
};

interface Props {
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  setView: Dispatch<SetStateAction<View>>;
  transferToggle: boolean;
  setTransferToggle: Dispatch<SetStateAction<boolean>>;
}

const TransferSection = ({
  createInputs,
  updateCreateInput,
  setView,
  transferToggle,
  setTransferToggle,
}: Props) => {
  const toggleTransfer = () => {
    updateCreateInput(null, 'reviewer');
    updateCreateInput(null, 'receiver');

    if (toggleTransfer) {
      updateCreateInput(null, 'toCategoryId');
      updateCreateInput(null, 'toCategoryPath');
    }

    setTransferToggle(!transferToggle);
  };

  return (
    <>
      <div>
        <div styleName="transfer-title">Transfer</div>
        <div styleName="transfer-title-sub">
          <div>
            Transfer the inventory to another district or division once the
            request is approved.
          </div>
          <Switch
            style={styles.switch}
            checked={transferToggle}
            onChange={toggleTransfer}
          />
        </div>
      </div>
      {transferToggle && (
        <>
          <div styleName="view-row">
            <div styleName="row-title">From District or Division</div>
            <div>{createInputs.categoryPath}</div>
          </div>
          <div styleName="view-row">
            <div styleName="row-title">To District or Division</div>
            {isNilOrEmpty(createInputs.toCategoryId) ? (
              <div
                styleName="select-button"
                onClick={() => setView(View.CATEGORY)}
              >
                SELECT
              </div>
            ) : (
              <div styleName="category-tile">
                <div>{createInputs.toCategoryPath}</div>
                <IconButton size="small" onClick={() => setView(View.CATEGORY)}>
                  <Icon>edit</Icon>
                </IconButton>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TransferSection;
